import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import lightningIcon from '../../../../assets/reimbursement-method/direct-deposit-banner/lightning.svg';

import { useReimbursementMethodDisclaimer } from '../../../../hooks';

import styles from './css/DirectDepositBanner.module.css';

export const DirectDepositBanner = ({
  containerClassName = '',
  notMethodSet = false,
  onSetupClick = null,
  validPolicyStatus = false,
}) => {
  const { t } = useTranslation('myAccount');
  const useReimbursementMethodDisclaimerFlag =
    useReimbursementMethodDisclaimer();

  const descriptionKey = useMemo(() => (notMethodSet
    ? 'reimbursementSection.directDepositBanner.description'
    : 'reimbursementSection.directDepositBanner.changeDescription'
  ), [notMethodSet]);

  if (!useReimbursementMethodDisclaimerFlag || !validPolicyStatus) {
    return null;
  }

  return (
    <div className={`${styles.bannerContainer} ${containerClassName}`}>
      <div className={styles.textColumn}>
        <div className={styles.titleRow}>
          <img alt="" className={styles.icon} src={lightningIcon} />

          <p className={styles.title}>
            {t('reimbursementSection.directDepositBanner.title')}
          </p>
        </div>

        <p className={styles.description}>
          {t(descriptionKey)}
        </p>
      </div>

      {onSetupClick && (
        <button
          className={styles.setupLink}
          onClick={onSetupClick}
          type="button"
        >
          {t('reimbursementSection.directDepositBanner.setUpDirectDeposit')}
        </button>
      )}
    </div>
  );
};
